import { FunctionComponent, useEffect, useState } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { getSubjects, getServices, getStatuses, getCategories, getIssues } from "../../../api/ticket/get";
import { updateTicket } from "../../../api/ticket/put";
import handleError from "../../../utils/handleError";
import handleNotfication from "../../../utils/handleNotfication";
import { translate } from "../../../utils/helpers";
import RonadIcons from "../../../components/iconComponent";

interface CategoryServiceFormProps {
  ticket: any
}
 
const CategoryServiceForm: FunctionComponent<CategoryServiceFormProps> = ({ticket}) => {
  const [categories, setCategories] = useState([])
  const [subjects, setSubjects] = useState([])
  const [issues, setIssues] = useState([])
  const [category, setCategory] = useState({})
  const [subject, setSubject] = useState({})
  const [issue, setIssue] = useState({})
  const [services, setServices] = useState([])
  const [statuses, setStatuses] = useState([])
  const [service, setService] = useState({})
  const [status, setStatus] = useState({})
  const [linkType, setLinkType] = useState()
  const [linkId, setLinkId] = useState()
  const [reason, setReason] = useState()

  useEffect(() => {
    getCategoryList()
    getServiceList()
    if(ticket) {
      console.log(ticket)
      setCategory(ticket?.category)
      setSubject(ticket?.subject)
      setIssue(ticket?.issue)
      setStatus(ticket?.serviceStatus)
      setService(ticket?.serviceStatus?.service)
      getIssueList(ticket?.category?.id)
      getSubjectList(ticket?.category.id)
      setReason(ticket?.reason)
      setLinkType(ticket?.linkType)
      setLinkId(ticket?.linkId)
    }
  }, []);
  
  const getCategoryList = async () => {
    try {
      const response = await getCategories({})
      setCategories(response.data)
    } catch (error) {
      console.log(error)
      handleError(error)
    }
  }

  const getSubjectList = async (id:string) => {
    try {
      const response = await getSubjects({categoryId: id})
      setSubjects(response.data)
    } catch (error) {
      handleError(error)
    }
  }

  const getIssueList = async (id:string) => {
    try {
      const response = await getIssues({id})
      setIssues(response.data)
    } catch (error) {
      handleError(error)
    }
  }

  const getServiceList = async () => {
    try {
      const response = await getServices({})
      setServices(response.data)
    } catch (error) {
      handleError(error)
    }
  }

  const getStatusList = async (id:string) => {
    try {
      const response = await getStatuses(id)
      setStatuses(response.data)
    } catch (error) {
      handleError(error)
    }
  }

  const saveChanges = async () => {
    try {
      await updateTicket(ticket.id, {
        category: category.id, 
        subject: subject?.id, 
        serviceId: status?.id, 
        issueId: issue?.id,
        linkType,
        linkId,
        reason
      })
      handleNotfication('تیکت با موفقیت بروز شد.', 'success')
    } catch (error) {
      console.log(error)
      handleError(error)
    }
  }
  const assignService = async () => {
    try {
      await updateTicket(ticket.id, {serviceId: status.id})
      handleNotfication('فرآیند با موفقیت تغییر کرد.', 'success')
    } catch (error) {
      handleError(error)
    }
  }

  const removeService = async () => {
    try {
      await updateTicket(ticket.id, {serviceId: null})
      setStatus({})
      setService({})
      handleNotfication('فرآیند با موفقیت حذف شد.', 'success')
    } catch (error) {
      handleError(error)
    }
  }
  return ( 
    <Grid container alignItems='center' spacing={1} style={{marginBottom: '12px', padding: "12px", backgroundColor: "#fff"}}>
      <Grid item md={2}>
        <Autocomplete
          id="category"
          options={categories}
          value={category}
          inputValue={category.name}
          getOptionLabel={option => option.name}
          disableClearable={true}
          onChange={(e: any, newValue: any | null | undefined) => {
            if (newValue) {
              setCategory(newValue);
              setSubject({})
              setIssue({})
              getSubjectList(newValue.id)
              getIssueList(newValue.id)
            }
          }}
          renderInput={params => (
            <TextField
              name="category"
              {...params}
              label="دسته‌بندی"
              fullWidth
              variant="outlined"
            />
          )}
        />
      </Grid>
      <Grid item md={2}>
        <Autocomplete
          id="subject"
          options={subjects}
          value={subject}
          inputValue={subject.body}
          onChange={(event: any, newValue: any | null) => {
            if (newValue) {
              setSubject(newValue);
            }
          }}
          getOptionLabel={option => option?.body}
          disableClearable={true}
          renderInput={params => (
            <TextField
              name="subject"
              {...params}
              label="موضوع"
              variant="outlined"
            />
          )}
        />
      </Grid>
      <Grid item md={2}>
        <Autocomplete
          id="issue"
          options={issues}
          value={issue}
          inputValue={subject.name}
          onChange={(event: any, newValue: any | null) => {
            setIssue(newValue);
          }}
          getOptionLabel={option => option?.name}
          disableClearable={true}
          renderInput={params => (
            <TextField
              name="issue"
              {...params}
              label="مشکل"
              variant="outlined"
            />
          )}
        />
      </Grid>
      <Grid item md={2}>
        <Autocomplete
          id="service"
          options={services}
          value={service}
          inputValue={translate(service?.name)}
          getOptionLabel={option => translate(option.name)}
          disableClearable={true}
          onChange={(e: any, newValue: any | null | undefined) => {
            if (newValue) {
              setService(newValue);
              setStatus({})
              getStatusList(newValue.id)
            }
          }}
          renderInput={params => (
            <TextField
              name="service"
              {...params}
              label="فرآیند"
              fullWidth
              variant="outlined"
            />
          )}
        />
      </Grid>
      <Grid item md={2}>
        <Autocomplete
          id="status"
          options={statuses}
          value={status}
          inputValue={translate(status?.status)}
          onChange={(event: any, newValue: any | null) => {
            setStatus(newValue);
          }}
          getOptionLabel={option => translate(option?.status)}
          disableClearable={true}
          renderInput={params => (
            <TextField
              name="status"
              {...params}
              label="وضعیت فرآیند"
              variant="outlined"
            />
          )}
        />
      </Grid>
      {console.log(translate(linkType))}
      <Grid item md={2}>
        <Autocomplete
          id="linkType"
          options={['order','parcel']}
          value={linkType?? ''}
          inputValue={translate(linkType?? '')}
          onChange={(event: any, newValue: any | null) => {
            setLinkType(newValue);
          }}
          getOptionLabel={option => translate(option)}
          disableClearable={true}
          renderInput={params => (
            <TextField
              name="linkType"
              {...params}
              label="اتصال به"
              variant="outlined"
            />
          )}
        />
      </Grid>
      <Grid item md={2}>
        <TextField
          name="linkId"
          label="شناسه سفارش یا محموله"
          variant="outlined"
          fullWidth
          value={linkId}
          onChange={val => setLinkId(val.target.value)}
        />
      </Grid>
      <Grid item md={2}>
        <TextField
          name="reason"
          label="علت"
          variant="outlined"
          fullWidth
          value={reason}
          onChange={val => setReason(val.target.value)}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          size="medium"
          component="span"
          color="primary"
          onClick={saveChanges}
        >
          ذخیره
        </Button>
      </Grid>
      {ticket?.serviceStatus && <Grid item>
        <Button
          variant="outlined"
          size="medium"
          component="span"
          color="default"
          onClick={removeService}
        >
          حذف فرآیند
          <RonadIcons name="trash-01" className="mr-1" color="primary" size="18px"/>
        </Button>
        {/* <span className="flex pointer">
        </span> */}
      </Grid>}
    </Grid>
  );
}
 
export default CategoryServiceForm;